import React from 'react';
import Icon from '../../../components/AppIcon';

const FreePlanHighlight = () => {
  return (
    <div className="bg-gradient-to-r from-primary/10 via-accent/10 to-secondary/10 border-2 border-primary/20 rounded-2xl p-8 mb-12">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0 md:space-x-8">
          <div className="flex-shrink-0 w-20 h-20 bg-primary/20 rounded-2xl flex items-center justify-center">
            <Icon name="Gift" size={40} color="var(--color-primary)" />
          </div>

          <div className="flex-1 text-center md:text-left">
            <h3 className="text-2xl font-heading font-bold text-foreground mb-3">
              Start Free - Research & Plan Your Book
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              The Free Plan gives you complete access to <span className="font-semibold text-foreground">Agents 1-3</span> for title research, voice capture, and outline creation. 
              Perfect for exploring your book idea and creating a solid foundation. 
              <span className="block mt-2 text-sm text-accent font-medium">
                ✨ To unlock AI-powered writing and complete your book, upgrade to any paid plan.
              </span>
            </p>
          </div>

          <div className="flex-shrink-0">
            <div className="bg-card border-2 border-accent rounded-xl p-4 min-w-[200px]">
              <div className="text-center mb-3">
                <span className="text-3xl font-bold text-foreground">100%</span>
                <span className="text-muted-foreground ml-1">Free</span>
              </div>
              <ul className="space-y-2 text-sm">
                <li className="flex items-center space-x-2">
                  <Icon name="Check" size={14} color="var(--color-success)" />
                  <span className="text-foreground">Research topics</span>
                </li>
                <li className="flex items-center space-x-2">
                  <Icon name="Check" size={14} color="var(--color-success)" />
                  <span className="text-foreground">Capture your voice</span>
                </li>
                <li className="flex items-center space-x-2">
                  <Icon name="Check" size={14} color="var(--color-success)" />
                  <span className="text-foreground">Create outlines</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreePlanHighlight;